// extracted by mini-css-extract-plugin
export default {"container":"Extra_container__5TTQ9"};